// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 *
 * @export
 * @interface ExportRequirementsPayload
 */
export interface ExportRequirementsPayload {
  /**
   * Project ID
   * @type {number}
   * @memberof ExportRequirementsPayload
   */
  project: number;
  /**
   * Export data as CSV/EXCEL
   * @type {string}
   * @memberof ExportRequirementsPayload
   */
  exportAs: ExportRequirementsPayloadExportAsEnum;
  /**
   * Stringified filter object (Ag-grid filters)
   * @type {string}
   * @memberof ExportRequirementsPayload
   */
  filterModel?: string;
  /**
   * Stringified array of sort model objects (Ag-grid sort models)
   * @type {string}
   * @memberof ExportRequirementsPayload
   */
  sortModel?: string;
  /**
   * Export selected or all requirements. If none is selected and filter is present then all filtered requirements will be considered.
   * @type {string}
   * @memberof ExportRequirementsPayload
   */
  criteria: ExportRequirementsPayloadCriteriaEnum;
  /**
   * Selected requirement IDs - will be considered only if criteria is selected.
   * @type {Array<number>}
   * @memberof ExportRequirementsPayload
   */
  requirements?: Array<number>;
  /**
   * Fields provided here will be considered for export. If none then all default fields. Custom fields use the template \"cf_<customFieldId>\".
   * @type {Array<string>}
   * @memberof ExportRequirementsPayload
   */
  fields: Array<string>;
  /**
   * Strip HTML tags from text fields
   * @type {boolean}
   * @memberof ExportRequirementsPayload
   */
  removeTags?: boolean;
  /**
   * When true, only export requirements that are linked to at least one test case
   * @type {boolean}
   * @memberof ExportRequirementsPayload
   */
  hasLinkedTestCases?: boolean;
}

export function ExportRequirementsPayloadFromJSON(
  json: any
): ExportRequirementsPayload {
  return {
    project: json["project"],
    exportAs: json["export_as"],
    filterModel: !exists(json, "filter_model")
      ? undefined
      : json["filter_model"],
    sortModel: !exists(json, "sort_model") ? undefined : json["sort_model"],
    criteria: json["criteria"],
    requirements: !exists(json, "requirements")
      ? undefined
      : json["requirements"],
    fields: json["fields"],
    removeTags: !exists(json, "remove_tags") ? undefined : json["remove_tags"],
    hasLinkedTestCases: !exists(json, "has_linked_test_cases")
      ? undefined
      : json["has_linked_test_cases"],
  };
}

export function ExportRequirementsPayloadToJSON(
  value?: ExportRequirementsPayload
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    project: value.project,
    export_as: value.exportAs,
    filter_model: value.filterModel,
    sort_model: value.sortModel,
    criteria: value.criteria,
    requirements: value.requirements,
    fields: value.fields,
    remove_tags: value.removeTags,
    has_linked_test_cases: value.hasLinkedTestCases,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum ExportRequirementsPayloadExportAsEnum {
  Csv = "csv",
  Excel = "excel",
}
/**
 * @export
 * @enum {string}
 */
export enum ExportRequirementsPayloadCriteriaEnum {
  All = "all",
  Selected = "selected",
}
